import NacelleGraphQLConnector from '../connectors/graphql/nacelleGraphQLConnector'

interface NacelleStatusParams {
  connector?: NacelleGraphQLConnector
  endpoint?: string
  spaceId?: string
  token?: string
}

export default class NacelleStatus {
  connector: NacelleGraphQLConnector

  constructor(params: NacelleStatusParams) {
    if (params.connector) {
      this.connector = params.connector
    } else if (params.endpoint && params.spaceId && params.token) {
      this.connector = new NacelleGraphQLConnector({
        endpoint: params.endpoint,
        spaceId: params.spaceId,
        token: params.token
      })
    } else {
      throw new Error('Missing parameters to initialize checkout module')
    }
  }

  isVariantAvailable(params: {
    productId: string
    variantId: string
  }): Promise<boolean> {
    return this.connector.isVariantAvailable(params)
  }
}
